import { compose } from 'redux'

const initialState = {
  accountNumber: '00000',
  verifyingDigit: '0'
}

export const ACTION_TYPES = {
  ACCOUNT_REQUEST: 'ACCOUNT_REQUEST',
  ACCOUNT_SUCCESS: 'ACCOUNT_SUCCESS',
  ACCOUNT_ERROR: 'ACCOUNT_ERROR'
}
const DEPOSIT = 'Deposit'

export const requestAccount = (payload = {}) => ({
  type: ACTION_TYPES.ACCOUNT_REQUEST,
  payload
})

const mergeWithState = state => payload => Object.assign({}, state, payload)

const findAccount = accounts => accounts.find(({ accountType }) => accountType === DEPOSIT)

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case ACTION_TYPES.ACCOUNT_ERROR:
    case ACTION_TYPES.ACCOUNT_REQUEST:
      return mergeWithState(state)(payload)
    case ACTION_TYPES.ACCOUNT_SUCCESS:
      return compose(mergeWithState(state), findAccount)(payload)
    default:
      return state
  }
}

